import type { FC } from 'react';
import { css } from '@emotion/react';
import { Trans, useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { InlineNotification, Modal, TextLink, useModalControl, Text } from '@frontend/design-system';
import { AudioQueryMedia } from '../../utils/use-audio-query';
import { PhoneTreePreviewModal } from '../common/phone-tree-dropdown/phone-tree-preview-modal';

interface VoicemailIvrNotificationProps {
  ivrMenuId?: string;
  ivrMenuName?: string;
  audioFiles?: AudioQueryMedia;
}

export const VoicemailIvrNotification: FC<VoicemailIvrNotificationProps> = ({
  ivrMenuId,
  ivrMenuName,
  audioFiles = { customMedia: [], standardMedia: [], mailboxGreetings: [], allMedia: [] },
}) => {
  const { modalProps: previewPhoneTreeModalProps, triggerProps: previewPhoneTreeTriggerProps } = useModalControl();
  const { t } = useTranslation('phone');

  return (
    <>
      <InlineNotification
        status='warn'
        size='large'
        css={css`
          max-height: unset;
          margin-bottom: ${theme.spacing(2)};
        `}
      >
        <Trans t={t}>
          <Text size='medium'>
            <strong>Voicemail Overrides will now only send callers to voicemail.</strong> You have previously sent
            callers to a Phone Tree with this override. To maintain your previous override experience, select the{' '}
            <strong>Send to Phone Tree</strong> override type and select{' '}
            <TextLink {...previewPhoneTreeTriggerProps} trackingId='nwx-skip-schedule-warning-phone-tree-preview-link'>
              {ivrMenuName}
            </TextLink>{' '}
            as the Phone Tree.
          </Text>
        </Trans>
      </InlineNotification>

      <Modal {...previewPhoneTreeModalProps} minWidth={800} maxWidth={800}>
        <PhoneTreePreviewModal
          phoneTreeId={ivrMenuId ?? ''}
          name={ivrMenuName ?? ''}
          onClose={previewPhoneTreeModalProps.onClose}
          audioFiles={audioFiles ?? { customMedia: [], standardMedia: [], mailboxGreetings: [], allMedia: [] }}
        />
      </Modal>
    </>
  );
};
